import React from "react";
import styled from "styled-components";
import { colors } from "@sonder/ui/source/styled/theme";
import { resetFilters } from "search/actions";
import { SearchDateFilter } from "search/components/SearchDateFilter";
import { SearchStatusDropdown } from "search/components/SearchStatusDropdown";
import { useSearchStore } from "search/store";

const Wrapper = styled.div`
  color: ${colors.gray1};
  flex: 1;
  padding-left: 2.857rem;
`;

const FilterHeader = styled.div`
  font-size: 1.143rem;
  font-weight: 700;
  margin-bottom: 1.429rem;
`;

const DropdownLabel = styled.div`
  font-size: 0.857rem;
  margin-bottom: 0.429rem;
`;

const ResetWrapper = styled.div`
  color: ${colors.gray1};
  cursor: pointer;
  margin-top: 1.143rem;
`;

export const SearchPanel = () => {
  const { dispatch } = useSearchStore();

  return (
    <Wrapper>
      <FilterHeader>Filter your search</FilterHeader>

      <DropdownLabel>Filter by</DropdownLabel>
      <SearchStatusDropdown />

      <SearchDateFilter />

      <ResetWrapper onClick={() => dispatch(resetFilters())}>
        Reset
      </ResetWrapper>
    </Wrapper>
  );
};
